import React from 'react'
import styles from './header.jcss'
import Icon from '../../../blocks.simple/icon/icon'
import { colors } from '../../../theme'
import translate from '../../../core/translate'

interface IHeader {
    selectedItemsLength: number
    deleteAllSelected: (value: boolean) => void
    onAdd: () => void
    applyPreset?: () => void
}

export const Header = ({ selectedItemsLength, deleteAllSelected, onAdd, applyPreset }: IHeader) => {
    return (
        <div className={styles.header}>
            <div className={styles.controlPositionBlock}>
                <div className={styles.controlBlock}>
                    <Icon
                        type={'plus'}
                        color={colors.blueAccent}
                        size={18}
                        className={styles.addIcon}
                        onClick={onAdd}
                        tooltip={{ title: translate('add') }}
                    />
                    {applyPreset && (
                        <Icon
                            type={'settings'}
                            color={colors.blueAccent}
                            size={18}
                            className={styles.addIcon}
                            disabled={!selectedItemsLength}
                            onClick={applyPreset}
                        />
                    )}
                    <Icon
                        type={'delete'}
                        color={colors.blueAccent}
                        disabled={!selectedItemsLength}
                        size={18}
                        onClick={() => deleteAllSelected(true)}
                        tooltip={{ title: translate('delete') }}
                    />
                </div>
            </div>
            {/*<div className={styles.uploadBlock}>*/}
            {/*    <span>Разделитель</span>*/}
            {/*    <EditText*/}
            {/*        value={','}*/}
            {/*        onChange={(value: string) => {}}*/}
            {/*        containerClass={styles.separator}*/}
            {/*        className={styles.input}*/}
            {/*    />*/}
            {/*    <Button className={styles.refreshButton} onClick={() => {}} mod={'withAccent'}>*/}
            {/*        {translate('upload')}*/}
            {/*    </Button>*/}
            {/*</div>*/}
        </div>
    )
}
